<template>
    <div class="I1Btn" :style="{top:y + 'px',left:x+'px'}" v-on:click="selectBtn">

    </div>
</template>
<script>
export default {
    name: "Info1Btn",
    props: ["ID", "x", "y"],
    methods: {
        selectBtn() {
            this.$emit("btnClicked", this.ID);
        }
    }
}
</script>
<style scoped>
.I1Btn {
    position:absolute;
    width: 50px;
    height: 50px;
    background: rgb(2,0,36);
    background: -moz-linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(1,255,0,1) 100%);
    background: -webkit-linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(1,255,0,1) 100%);
    background: linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(1,255,0,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#020024",endColorstr="#01ff00",GradientType=1);
    border-radius: 50%;
    cursor: pointer;
}
</style>